/* eslint no-undef: 'off' */
import $ from "jquery";

/**
 * declare main attributes
 */
const ID_ATTR = "#wijzigingen, #lengte, #length";
const optionValueToCheck = "+";
if (
  $("#wijzigingen option, #lengte option, #length option").filter(function () {
    return $(this).val().includes(optionValueToCheck);
  }).length > 0
) {
  $(".single_add_to_cart_button").addClass("custom-a2c-btn");
}

let SUBMIT_BUTTON = ".custom-a2c-btn";
let PRICE_PER_METER = 0;
let MINIMUM_LENGTH = 0;

/**
 * restrict function
 */
const restrict = () => {
  const check = $(ID_ATTR).length;
  if (check < 1) return false;
  return true;
};

/**
 * get default data
 */
const get_default_data = () => {
  let add_to_cart = $('input[name="add-to-cart"]').val();
  let product_id = $('input[name="product_id"]').val();
  let variation_id = $('input[name="variation_id"]').val();
  let referentie = $("#referentie").val();
  let select_value = $(ID_ATTR).val();
  let custom_length = $("#sixhundredplus").val();
  let fels = $("#fels").val();

  return {
    add_to_cart: add_to_cart,
    product_id: product_id,
    variation_id: variation_id,
    referentie: referentie,
    select_value: select_value,
    custom_length: custom_length,
    fels: fels,
  };
};
get_default_data();
/**
 * check elements
 */
const activate_element = () => {
  $(document).on("change", ID_ATTR, function (e) {
    e.preventDefault();
    e.stopPropagation();

    let value = $(this).val();
    let status = value.endsWith("+");

    let $element = $("#custom_attr");
    let default_data = get_default_data();

    if (status) {
      $("#statusCustom").val("custom");
      $(".qib-button-wrapper").addClass("mi-hidden-element");
      check_price(default_data);
    } else {
      $("#statusCustom").val("non-custom");
      $(".qib-button-wrapper").removeClass("mi-hidden-element");
      $("#fels").prop("selectedIndex", 0);
      $element.addClass("mi-hidden-element");
      check_custom_price(default_data);
    }
  });
};

/**
 * ajax check price and default data
 */
const check_price = (data) => {
  data.action = parameters.mi_add_to_cart.action_check_price;
  data.nonce = parameters.nonceFE;
  let $element = $("#custom_attr");
  $element.addClass("is-loading");

  $(".woocommerce-variation-price").addClass("mi-hidden-price");
  $(ID_ATTR).prop("disabled", true);
  $(SUBMIT_BUTTON).prop("disabled", true);

  // console.log(data.action, data.nonce);

  $.ajax({
    type: "POST",
    data: data,
    url: parameters.url_admin_ajax,
    dataType: "json",
  })
    .done(function (res) {
      if (res.success) {
        $("#custom_label_length").text(res.data.minimum_lengh_lable);
        $("#custom_label_price").text(res.data.label_price);
        $("#sixhundredplus").val(res.data.minimum_lengh);
        $("#sixhundredplus").prop("min", res.data.minimum_lengh);
        $("#sixhundredplus").prop("step", 0.1);
        $(
          ".woocommerce-variation-price .price .woocommerce-Price-amount.amount bdi"
        ).html(res.data.initial_price);

        PRICE_PER_METER = res.data.price_per_meter;
        MINIMUM_LENGTH = res.data.minimum_lengh;

        // remove class
        $(".woocommerce-variation-price").removeClass("mi-hidden-price");
        $element.removeClass("mi-hidden-element is-loading");
      } else {
        alert(res.data);
      }
    })
    .always(function () {
      // remove class
      $element.removeClass("is-loading");
      $(ID_ATTR).prop("disabled", false);
      $(SUBMIT_BUTTON).prop("disabled", false);
    });
};

/**
 * ajax check custom price and default data
 */
const check_custom_price = (data) => {
  data.action = parameters.mi_add_to_cart.action_check_custom_price;
  data.nonce = parameters.nonceFE;
  let $element = $("#custom_attr");
  $element.addClass("is-loading");

  $(".woocommerce-variation-price").addClass("mi-hidden-price");
  $(ID_ATTR).prop("disabled", true);
  $(SUBMIT_BUTTON).prop("disabled", true);

  $.ajax({
    type: "POST",
    data: data,
    url: parameters.url_admin_ajax,
    dataType: "json",
  })
    .done(function (res) {
      if (res.price != 0) {
        $(
          ".woocommerce-variation-price .price .woocommerce-Price-amount.amount bdi"
        ).html(res.price);
      }
    })
    .always(function () {
      // remove class
      $element.removeClass("is-loading");
      $(ID_ATTR).prop("disabled", false);
      $(SUBMIT_BUTTON).prop("disabled", false);

      $(".woocommerce-variation-price").removeClass("mi-hidden-price");
      $element.removeClass("is-loading");
    });
};

/**
 * change meter
 */
const input_meter = () => {
  $(document).on("input", "#sixhundredplus", function (e) {
    e.stopPropagation();
    e.preventDefault();

    let input_val = $(this).val();
    let price = MINIMUM_LENGTH * PRICE_PER_METER;
    price = price.toFixed(2);
    price = `${price}`;

    price = input_val * PRICE_PER_METER;
    price = price.toFixed(2);
    price = `€${price}`;
    $(
      ".woocommerce-variation-price .price .woocommerce-Price-amount.amount bdi"
    ).html(price);
  });
};

/**
 * add to cart
 */
const custom_add_to_cart = () => {
  $(document).on("click", SUBMIT_BUTTON, function (e) {
    e.preventDefault();
    e.stopPropagation();

    if ($(SUBMIT_BUTTON).hasClass("wc-variation-is-unavailable")) return false;

    $(SUBMIT_BUTTON).prop("disabled", true);
    let supplierNumber = $('select[name=attribute_artikelnummers-leverancier]');

    let data = get_default_data();
    let statusAddToCart = $("#statusCustom").val();
    let quantity = $('input[name="quantity"]').val();
    let notify1 = $("#notify1").text();
    let notify2 = $("#notify2").text();
    let notify3 = $("#notify3").text();

    data.status = statusAddToCart;
    data.quantity = quantity;
    data.action = parameters.mi_add_to_cart.action_add_to_cart;
    data.nonce = parameters.nonceFE;
    
    if (data.custom_length < MINIMUM_LENGTH) {
      alert(notify1 + MINIMUM_LENGTH);
      $(SUBMIT_BUTTON).prop("disabled", false);
      return;
    }
    
    if (supplierNumber.length) {
      data['attribute_artikelnummers-leverancier'] = supplierNumber.val();
      if (!data['attribute_artikelnummers-leverancier']) {
        alert(notify3);
        $(SUBMIT_BUTTON).prop("disabled", false);
        return;
      }
    }

    if (((Number(data.custom_length) * 100) % 10) / 100 !== 0) {
      alert(notify2);
      $(SUBMIT_BUTTON).prop("disabled", false);
      return;
    }

    $.ajax({
      type: "POST",
      data: data,
      url: parameters.url_admin_ajax,
      dataType: "json",
    })
      .done(function (res) {
        if (res.success) {
          $(document.body).trigger("wc_fragment_refresh");
          $(".woocommerce-notices-wrapper").prepend(res.data);
          $("body, html").animate({ scrollTop: 0 }, "slow");
          // setTimeout(function () {
          //   location.reload();
          // }, 2000);
        } else {
          $(document.body).trigger("wc_fragment_refresh");
          $(".woocommerce-notices-wrapper").prepend(res.data);
        }
      })
      .always(function () {
        $(SUBMIT_BUTTON).prop("disabled", false);
      });
  });
};

/**
 * initiate all function
 */
const init = () => {
  try {
    let check = restrict();
    if (check) {
      $("#wijzigingen").prop("selectedIndex", 0);
      $(
        "<input id='statusCustom' type='hidden' value='non-custom' />"
      ).insertAfter("#wijzigingen");

      activate_element();
      input_meter();
      custom_add_to_cart();
    }
  } catch (e) {
    console.log(e);
  }
};

/**
 * run all function
 */
init();
